import { render } from "./ExpertStatisticsAnswerUnansweredDailyCalls.vue?vue&type=template&id=74596f26"
import script from "./ExpertStatisticsAnswerUnansweredDailyCalls.vue?vue&type=script&lang=js"
export * from "./ExpertStatisticsAnswerUnansweredDailyCalls.vue?vue&type=script&lang=js"

import "./ExpertStatisticsAnswerUnansweredDailyCalls.vue?vue&type=style&index=0&id=74596f26&lang=css"
script.render = render

export default script